<template>
  <section class="fondo">
    <div class="shape">
      <v-container id="container">
        <v-row align="center" style="min-height: 90vh" class="pt-15">
          <v-col cols="12">
            <v-row justify="center">
              <v-col
                cols="10"
                md="5"
                xl="5"
                align-self="center"
                justify="center"
                class="py-10"
              >
                <h1
                  v-scrollanimation
                  class="text-md-h3 text-xl-h2 font-weight-regular mb-4"
                >
                  {{ $t("mensaje") }}
                </h1>
                <p v-scrollanimation class="grisClaro--text">
                  {{ $t("definicion") }}
                </p>
                <!-- 
                  <v-btn
                  v-scrollanimation
                    large
                    color="accent"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="btn mt-5 mr-5"
                    rounded
                    
                  ><span>
                    {{ $t("info.verMas") }}
                    </span>
                  </v-btn> -->
              </v-col>

              <v-col cols="10" md="5" xl="5" class="pa-0">
                <v-img
                  class="mt-15"
                  src="@/assets/vect/usability-testing-animate.svg"
                  contain
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row align="start" class="flecha">
          <v-col cols="12" class="d-flex justify-center">
            <div color="transparent" class="arrow d-flex justify-center">
              <svg
                id="Icon"
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 40 40"
              >
                <rect
                  id="Area"
                  width="40"
                  height="40"
                  fill="#fcfcfc"
                  opacity="0"
                />
                <g
                  id="Icon-2"
                  data-name="Icon"
                  transform="translate(9.905 14.858)"
                  class="secondary"
                >
                  <path
                    id="Path"
                    d="M5,7.5l9.905,9.905L24.811,7.5"
                    transform="translate(-5 -7.5)"
                    fill="none"
                    stroke="#3d3d3d"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="4"
                  />
                </g>
              </svg>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </section>
</template>

<script>
export default {
  name: "Landing",
  data() {
    return {
      dialog: false,
      isActive: false,
      cajon: true,
    };
  },
};
</script>

<style scoped>
section {
  min-height: 100vh;
}
.shape {
  background-image: url(../../../assets/formas/shape1.svg);
  background-position: top right;
  background-repeat: no-repeat;
  background-size: 30rem;
  background-attachment: fixed;
}

#container {
  min-height: 100vh;
}

.text-md-h3,
.text-xl-h2 {
  font-family: "Quicksand", sans-serif !important;
}

.flecha {
  z-index: 10;
}

.arrow {
  width: 2rem;
  height: 4rem;
  border: 1px transparent #171e54;
  border-radius: 1rem;
  z-index: 1;
}

.arrow svg {
  display: block;
  animation: arrow 1s ease-in-out infinite;
}

@keyframes arrow {
  0% {
    opacity: 0;
    transform: translateY(0.5rem);
  }
  100% {
    opacity: 1;
    transform: translateY(1.5rem);
  }
}

h1.before-enter {
  opacity: 0;
  transform: translateX(-50px);
  transition: all 0.5s ease-in-out;
}

h1.enter {
  opacity: 1;
  transform: translateX(0px);
}

p.before-enter {
  opacity: 0;
  transform: translateX(-50px);
  transition: all 1s ease-in-out;
}

p.enter {
  opacity: 1;
  transform: translateX(0px);
}

.before-enter.btn {
  opacity: 0;

  transition: all 1.5s ease-in-out;
}

.enter.btn {
  opacity: 1;
}
</style>
